import React, {useEffect, useRef, useState} from 'react';
import {useFormik} from 'formik'
import {Button, Collapse, Empty, Input, Modal, Skeleton, Spin} from "antd";
import {ErrorMessageWidget} from "@/components/form/errorMessageWidget";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useParams} from "react-router-dom";
import {
    useApiCreateAdminPollQuestion,
    useApiSearchAdminPollQuestionSurveyId,
    useApiUpdateAdminPollSurveySort
} from "@/api/question";
import {GripVertical, PlusIcon} from "lucide-react";
import EditQuestionSection from "@/pages/admin/survey/edit/_section/editQuestionSection";
import toFaNumber from "@/lib/utils/number";
import {ReactSortable} from "react-sortablejs";
import {Can} from "@/components/can/Can";
import PermList from "@/lib/helper/PermList";

function QuestionSurveySection() {

    const param = useParams()
    const survey_id = param.id;

    const [openAddModal, setOpenAddModal] = useState(false)
    const [optionTypeSelection, setOptionTypeSelection] = useState('single_choice')
    const [randoOption, setRandomOption] = useState(false)
    const [localQuestions, setLocalQuestions] = useState([])
    const AddQuestionRef = useRef(null);

    const {
        data,
        isPending: isPendingGet,
        refetch,
        isRefetching
    } = useApiSearchAdminPollQuestionSurveyId({survey_id: survey_id})
    const {mutate: addQuestion, isPending: isPendingAdd} = useApiCreateAdminPollQuestion()
    const {mutate: sortQuestions, isPending: isPendingSort} = useApiUpdateAdminPollSurveySort();

    useEffect(() => {
        if (data?.data?.data) {
            setLocalQuestions(data.data?.data);
        }
    }, [data?.data]);

    const formik = useFormik({
        initialValues: {}, validate: (values) => {
            return {};
        }, onSubmit: (values) => {

            values.random_options = randoOption
            values.type = optionTypeSelection
            values.survey_id = survey_id

            addQuestion(values,
                {
                    onSuccess: (res) => {
                        formik.resetForm()
                        refetch()
                        setOpenAddModal(false)
                        ApiHandleSuccessMessage(res)

                    },
                    onError: (res) => {
                        ApiHandleErrorMessage(res)
                    },
                })


        }
    })


    useEffect(() => {
        if (openAddModal && AddQuestionRef.current) {
            setTimeout(() => {
                AddQuestionRef.current.focus();
            }, 100);
        }
    }, [openAddModal]);

    const onSortEnd = (newState) => {
        setLocalQuestions(newState);

        const sortData = newState.map((item, index) => ({
            id: parseInt(item.id),
            position: index + 1
        }));

        sortQuestions({survey_id: survey_id, sort: sortData}, {
            onSuccess: (res) => {
                ApiHandleSuccessMessage(res);
            },
            onError: (res) => {
                ApiHandleErrorMessage(res);
                // refetch();
            }
        });
    };

    return (<>
            <Can permission={PermList.SURVEY_EDIT}>
                <Modal
                    open={openAddModal}
                    onCancel={() => setOpenAddModal(false)}
                    footer={[
                        <div className={`mt-4 flex justify-end`}>


                            <Button onClick={formik.submitForm} type={'primary'} loading={isPendingAdd}
                            >
                                {'افزودن سوال'}
                            </Button>
                        </div>
                    ]}
                >

                    <div className={`flex flex-col gap-1`}>
                        <span className={`font-medium`}>عنوان سوال </span>
                        <Input placeholder={"عنوان را وارد کنید"}
                               disabled={isPendingAdd}
                               value={formik.values.title}
                               ref={AddQuestionRef}
                               status={formik.errors.title && "error"}
                               onChange={(e) => formik.setFieldValue("title", e.target.value)}
                               onPressEnter={() => formik.submitForm()}
                        />
                        {formik.errors.title && <ErrorMessageWidget message={formik.errors.title}/>}
                    </div>


                </Modal>
            </Can>


            {localQuestions.length <= 0 ? <Empty description={'هنوز هیچ سوالی ثبت نکرده اید'}>
                    <Can permission={PermList.SURVEY_EDIT}>
                        <Button onClick={() => setOpenAddModal(!openAddModal)} type="primary">افزودن سوال جدید</Button>
                    </Can>

                </Empty>
                :
                <div className="flex justify-end">
                    <Can permission={PermList.SURVEY_EDIT}>
                        <Button
                            icon={<PlusIcon className="h-4 w-4"/>}
                            className="flex items-center"
                            type={'dashed'}
                            onClick={() => setOpenAddModal(!openAddModal)}
                        >
                            افزودن سوال جدید
                        </Button>
                    </Can>
                </div>}


            {isPendingGet && <Skeleton active/>}


            {localQuestions.length > 0 &&
                <>
                    <div className={'flex flex-col gap-2 my-2'}>
                        <ReactSortable

                            list={localQuestions}
                            setList={setLocalQuestions}
                            onEnd={({newIndex, oldIndex}) => {
                                if (newIndex !== oldIndex) {
                                    const newState = [...localQuestions];
                                    const [movedItem] = newState.splice(oldIndex, 1);
                                    newState.splice(newIndex, 0, movedItem);
                                    onSortEnd(newState);
                                }
                            }}
                            handle=".drag-handle"
                            animation={150}
                            disabled={isPendingSort}
                        >
                            {localQuestions.map((item, index) => (
                                <div
                                    key={item.id}
                                    className="mb-2 rounded shadow-sm"
                                >
                                    <div className="flex items-center">
                                        <div className="drag-handle cursor-move p-2 hover:bg-gray-50 dark:hover:bg-gray-700">
                                            <GripVertical className="h-5 w-5 text-gray-400"/>
                                        </div>
                                        <div className="flex-1">
                                            <Collapse
                                                accordion
                                                items={[{
                                                    key: item.id,
                                                    label: (
                                                        <div className="flex items-center">
                                                            <span className="ml-2">{toFaNumber(index + 1)}.</span>
                                                            <span>{item.title}</span>
                                                        </div>
                                                    ),
                                                    children: <EditQuestionSection refetch={refetch} question={item}
                                                                                   index={index}/>
                                                }]}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </ReactSortable>
                    </div>
                </>
            }
            {(isRefetching || isPendingSort) && <div className={'flex justify-center'}><Spin/></div>}


        </>


    )
}

export default QuestionSurveySection;


